import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplates } from '@api/configurationTemplates';

import { extractQueryParams } from '@utils/common';

import { IConfigurationTemplate } from '@interfaces/cmModule/configurationTemplates';
import { IConfigurationTemplateDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES } from '@constants/queryKeys';

interface IUseQueryConfigurationTemplates {
	configTemplates: IConfigurationTemplate[];
	countOfRecords: number;
	isLoadingConfigTemplates: boolean;
}

const useQueryConfigurationTemplates = (params: IConfigurationTemplateDTO): IUseQueryConfigurationTemplates => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONFIGURATION_TEMPLATES, params],
		queryFn: extractQueryParams(getConfigurationTemplates),
		enabled: [!!params.page, !!params.pageSize],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		configTemplates: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingConfigTemplates: isInitialLoading,
	};
};

export default useQueryConfigurationTemplates;
